"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerWidgetTypes = void 0;
var PartnerWidgetTypes;
(function (PartnerWidgetTypes) {
    PartnerWidgetTypes["Szd"] = "szd";
    PartnerWidgetTypes["IDP"] = "idp";
    PartnerWidgetTypes["PIDPE"] = "pidpe";
    PartnerWidgetTypes["FC"] = "fc";
    PartnerWidgetTypes["FCT"] = "fct";
    PartnerWidgetTypes["NATM"] = "natm";
    PartnerWidgetTypes["NATMT"] = "natmt";
    PartnerWidgetTypes["NATMS"] = "natms";
    PartnerWidgetTypes["NATMSF"] = "natmsf";
})(PartnerWidgetTypes = exports.PartnerWidgetTypes || (exports.PartnerWidgetTypes = {}));
